export default "__VITE_ASSET__CgQVLHD$__"